import { render, staticRenderFns } from "./CandidateProfile.vue?vue&type=template&id=bf36fd1e&scoped=true"
import script from "./CandidateProfile.vue?vue&type=script&lang=ts"
export * from "./CandidateProfile.vue?vue&type=script&lang=ts"
import style0 from "./CandidateProfile.vue?vue&type=style&index=0&id=bf36fd1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf36fd1e",
  null
  
)

export default component.exports